import { render, staticRenderFns } from "./TotalFleetCreateOrUpdate.vue?vue&type=template&id=00bbf6e6&"
import script from "./TotalFleetCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./TotalFleetCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports